/**
 * Action types
 */
export const ActionTypes = {
  FORM_BUILDER_UPLOADER_SAVE_REQUEST: "FORM_BUILDER_UPLOADER_SAVE_REQUEST",
  FORM_BUILDER_UPLOADER_SAVE_SUCCESS: "FORM_BUILDER_UPLOADER_SAVE_SUCCESS",
  FORM_BUILDER_UPLOADER_SAVE_FAILURE: "FORM_BUILDER_UPLOADER_SAVE_FAILURE",
  FORM_BUILDER_UPLOADER_CLEAN_UP: "FORM_BUILDER_UPLOADER_CLEAN_UP",
};
